import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=e34d5980&scoped=true&"
import script from "./LayoutMain.vue?vue&type=script&lang=js&"
export * from "./LayoutMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34d5980",
  null
  
)

export default component.exports